import React from 'react'
import ScanRewardRow from './ScanRewardRow'
import 'react-popper-tooltip/dist/styles.css'
import './style.scss'

const tableHeaders = ['ID', 'Reward Value', 'Issued At']

const ScanRewardsTableProperties = () => {
  return {
    headers: tableHeaders,
    row: ({ id, issuedAt, reason, campaignId, customerId }) => {
      // Support both new (issuedAt) and old (issued_at) formats
      const issuedDate = issuedAt
      // Support both new (reason.reward) and old (reward) formats
      const rewardData = reason?.reward

      return (
        <ScanRewardRow
          id={id}
          reward={rewardData}
          issued_at={issuedDate}
          campaignId={campaignId}
          customerId={customerId}
        />
      )
    },
  }
}

export default ScanRewardsTableProperties
